export enum EModelApiPaths {
    API = '/api',
    CUSTOM_API_BASE = '/custom-api',
    SYSTEM_API_BASE = '/system-api',
    THIRD_PARTY_API_BASE = '/third-party',

    USER_LOGIN = '/madhuram/madhuram-login',
    FILE_UPLOAD_ORDER = '/madhuram/upload-file?uploadToPath=/order_files',
    FILE_UPLOAD = '/madhuram/upload-file?uploadToPath=/payment_receipts',
    ORDER_PLACE_EMAIL_OR_NOTIFICATION = '/madhuram/order-Place/email-or-notification',
    CONTACT_MAIL_SEND = '/madhuram/contact-mail-send',
    FORGOT_PASSWORD = '/madhuram/forgot-password',
    NEW_USER_REGISTRATION = '/madhuram/new-user-registration',
}
